var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaterDayImageActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 14.615,
    fill: "#CFEFFF",
    stroke: "#2BA3DE",
    strokeWidth: 2.77
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.211 12.353C22.7524 12.8944 22.7524 13.7722 22.211 14.3136L15.9173 20.6073C15.6573 20.8673 15.3046 21.0133 14.937 21.0133C14.5693 21.0133 14.2166 20.8673 13.9566 20.6073L11.0196 17.6702C10.4782 17.1288 10.4782 16.251 11.0196 15.7096C11.561 15.1682 12.4388 15.1682 12.9802 15.7096L14.937 17.6664L20.2504 12.353C20.7918 11.8115 21.6696 11.8115 22.211 12.353Z",
    fill: "#2BA3DE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterDayImageActive);
export default __webpack_public_path__ + "static/media/waterDayImageActive.b8114e7b6e5ca0b5b1db963f9ebab1aa.svg";
export { ForwardRef as ReactComponent };